import { render, staticRenderFns } from "./wait_work.vue?vue&type=template&id=189e245d&scoped=true&"
import script from "./wait_work.vue?vue&type=script&lang=js&"
export * from "./wait_work.vue?vue&type=script&lang=js&"
import style0 from "./wait_work.vue?vue&type=style&index=0&id=189e245d&scoped=true&lang=less&"
import style1 from "./wait_work.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189e245d",
  null
  
)

export default component.exports